import { render } from "./PatientCreateUnderlyingDiseases.vue?vue&type=template&id=d96b71f4&scoped=true"
import script from "./PatientCreateUnderlyingDiseases.vue?vue&type=script&lang=js"
export * from "./PatientCreateUnderlyingDiseases.vue?vue&type=script&lang=js"

import "./PatientCreateUnderlyingDiseases.vue?vue&type=style&index=0&id=d96b71f4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d96b71f4"]])

export default __exports__